(function () {

    'use strict';

    angular
        .module('AutoPrequal')
        .directive('modal', ['$rootScope', '$timeout', function ($rootScope, $timeout) {
            return {
                restrict: 'A',
                scope: {
                    modal: "=",
                },
                link: function (scope, element, attrs, ngModel) {

                    var modalWindowQ = $(element).find(".modal");

                    var firstToFocus = $(element).find(".first-to-focus");

                    var firstToFocusMobile = $(element).find(".first-to-focus-mobile");

                    var modalClose = $(element).find(".close-modal");

                    var modalCloseMain = $(element).find(".close-modal-main");

                    var modalAll = $(element).find("*");

                    var closeDisabled = element.hasClass('disable-close');

                    //add region role to all modals

                    modalWindowQ.attr("role", "region");


                    var unwatch = scope.$watch('modal', function (newVal, oldVal) {
                        if (newVal == true) {
                            $timeout(function () {
                                firstToFocus.focus();
                            });
                        }
                        else if ($rootScope.modalTrigger) {
                            $timeout(function () {
                                $rootScope.modalTrigger.focus();
                            }, 100);
                        }
                        $rootScope.modalOpen = newVal;
                    });

                    modalClose.bind('click', function (event) {
                        scope.$apply(function () {
                            scope.modal = false;
                        });
                    });

                    modalClose.bind("keydown keypress", function (event) {
                        if (event.which === 13) {
                            scope.$apply(function () {
                                scope.modal = false;
                            });
                            event.preventDefault();
                        }
                    });

                    modalAll.bind("keydown keypress", function (event) {
                        if (event.which === 27 && !closeDisabled) {
                            scope.$apply(function () {
                                scope.modal = false;
                            });
                            event.preventDefault();
                        }
                    });

                    modalCloseMain.bind("keydown keypress", function (event) {

                        if (!event.shiftKey && event.keyCode == 9) {
                            $timeout(function () {

                                if (!firstToFocus.is(':visible') && firstToFocusMobile.length && firstToFocusMobile.is(':visible')) {
                                    firstToFocusMobile.focus();
                                }
                                else {
                                    firstToFocus.focus();
                                }

                            }, 100);
                        }

                    });


                    firstToFocus.bind("keydown keypress", function (event) {

                        if (event.shiftKey && event.keyCode == 9) {
                            $timeout(function () {
                                modalCloseMain.focus();
                            });
                        }

                    });

                    firstToFocusMobile.bind("keydown keypress", function (event) {

                        if (!firstToFocus.is(':visible')) {
                            if (event.shiftKey && event.keyCode == 9) {
                                $timeout(function () {
                                    modalCloseMain.focus();
                                });
                            }
                        }
                    });

                    modalWindowQ.bind("keydown keypress", function (event) {
                        if (event.shiftKey && event.keyCode == 9 && $(this).is(":focus")) {
                            $timeout(function () {
                                modalCloseMain.focus();
                            });
                        }
                    });

                    scope.$on('$destroy', function () { unwatch(); })

                }
            }
        }]);

})();
